import { useNavigate } from "react-router-dom"

export default function SearchsingleNotes(props) {
    const navigate = useNavigate();

    const noteMoreclickHandler = () => {
        navigate(`/Home/Note/${props.id}`)
    }

    return (
        <div className='singleNoteContainer' style={{
            border: "1px solid gray", position: "relative"
            , display: "flex", alignItems: "center", justifyContent: "space-between", flexDirection: "column", padding: "10px"
        }}>

            <span style={{ position: "absolute", bottom: "-15px", left: "0px", fontSize: "45px", fontWeight: "700", color: "gray" }}>{props.index + 1}</span>

            <h4 className='noteHeading text' style={{ margin: "4px" }}>{(props.event.title).toUpperCase()}</h4>

            <p className='noteContent text' style={{ textTransform: "capitalize" }}>{(props.event.content).slice(0, 100)}
                {(props.event.content).length > 100 && <span style={{ color: "blue", fontWeight: "600", cursor: "pointer" }}
                    onClick={noteMoreclickHandler}
                > &nbsp; More...</span>}
            </p>



            <div style={{ position: "absolute", bottom: "5px", right: "10px" }}>
                <i className="bi bi-pencil-square"
                    data-bs-toggle="modal" data-bs-target="#UpdateNotes" style={{ cursor: "pointer", fontSize: "30px", color: "blue" }}
                    onClick={props.UpdateclickHndler}></i>

                &nbsp; &nbsp;

                <i className="bi bi-trash3"
                    data-bs-toggle="modal" data-bs-target="#deleteNotes" style={{ cursor: "pointer", fontSize: "30px", color: "red" }}
                    onClick={props.DeleteclickHndler}></i>
            </div>

            <div></div>
        </div>
    )
}
